var _rect, _path, _rect2, _rect3, _rect4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClip56(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 2,
    width: 32,
    height: 52,
    rx: 4,
    fill: "#309FF1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 44C16 42.8954 16.8954 42 18 42H22C23.1046 42 24 42.8954 24 44V48C24 49.1046 23.1046 50 22 50H18C16.8954 50 16 49.1046 16 48V44Z",
    fill: "#F5F5FF",
    fillOpacity: 0.68
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 46,
    width: 14,
    height: 4,
    rx: 2,
    fill: "#F5F5FF",
    fillOpacity: 0.68
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 40,
    width: 4,
    height: 4,
    rx: 2,
    fill: "#F5F5FF",
    fillOpacity: 0.68
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 34,
    width: 4,
    height: 4,
    rx: 2,
    fill: "#F5F5FF",
    fillOpacity: 0.68
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClip56);
export default __webpack_public_path__ + "static/media/clip_56.585ccdff.svg";
export { ForwardRef as ReactComponent };